module.exports = __webpack_public_path__ + "img/icon-lock-muted.1fa1c4cf.svg";